<template>
    <div class="register-info-company">
        <el-card shadow="always">
            <el-form ref="form" :model="form" label-position="left" label-width="" :rules="rules">
                <!-- 公司中文名 -->
                <el-form-item label="" prop="companyNameZh">
                    <el-input 
                        type="text" 
                        :placeholder="$t('Placeholder.EnterCompanyName')" 
                        v-model.trim="form.companyNameZh" 
                        clearable>
                    </el-input>
                </el-form-item>
                <!-- 公司英文名 -->
                <el-form-item label="" prop="companyNameEn">
                    <el-input 
                        type="text" 
                        :placeholder="$t('Placeholder.EnterCompanyNameEN')" 
                        v-model="form.companyNameEn" 
                        clearable
                        v-trim>
                    </el-input>
                </el-form-item>
                <!-- 所属部门名称 -->
                <el-form-item label="" prop="departmentName">
                    <el-input 
                        type="text" 
                        :placeholder="$t('Placeholder.DepartmentName')" 
                        v-model.trim="form.departmentName" 
                        clearable>
                    </el-input>
                </el-form-item>
                <!-- 职位 -->
                <el-form-item label="" prop="positionName">
                    <el-input 
                        type="text" 
                        :placeholder="$t('Placeholder.PositionName')" 
                        v-model.trim="form.positionName" 
                        clearable>
                    </el-input>
                </el-form-item>
                <!-- 姓名 -->
                <el-form-item label="" prop="uname">
                    <el-input 
                        type="text" 
                        :placeholder="$t('Placeholder.Uname')" 
                        v-model.trim="form.uname" 
                        clearable>
                    </el-input>
                </el-form-item>
                <!-- 推荐人 -->
                <el-form-item label="" prop="refereeName">
                    <el-input 
                        type="text" 
                        :placeholder="$t('Placeholder.RefereeName')" 
                        v-model.trim="form.refereeName" 
                        clearable>
                    </el-input>
                </el-form-item>
                <!-- 备注 -->
                <el-form-item label="" prop="remark">
                    <el-input 
                        type="text" 
                        :placeholder="$t('Placeholder.EnterNote')" 
                        v-model.trim="form.remark" 
                        clearable>
                    </el-input>
                </el-form-item>

                <!-- 所在地区 -->
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="" prop="country">
                            <el-select 
                                v-model="form.country" 
                                :placeholder="$t('Placeholder.Country')"
                                @change="handleRegionChange">
                                <el-option
                                    v-for="(item, index) in countryList"
                                    :key="index"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="" prop="region">
                            <el-select
                            class="region-select"
                            v-model="form.region" 
                            :placeholder="$t('Placeholder.Region')"
                            :disabled="form.country === '1'"
                            @change="handleRegionChange">
                                <el-option
                                    v-for="item in provinceList"
                                    :key="item.provincecode"
                                    :label="language === 'zh' ? item.provincename : item.provinceNameEN"
                                    :value="item.provincecode">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                
                <!-- 手机号 -->
                <el-form-item label="" prop="phone">
                    <el-input 
                        type="text" 
                        :placeholder="$t('Placeholder.YourPhoneNumber')" 
                        v-model.trim="form.phone" 
                        clearable>
                    </el-input>
                </el-form-item>
                <!-- 图形验证码 -->
                <el-form-item label="" prop="captcha" class="captcha-img">
                    <el-input 
                        type="text" 
                        :placeholder="$t('Placeholder.EnterImgCaptcha')" 
                        v-model.trim="form.captcha">
                        <img slot="suffix" :src="captchaImgUrl" @click="getImgCaptcha" />
                    </el-input>
                </el-form-item>
                <!-- 短信验证码 -->
                <el-form-item label="" prop="code" v-if="showSmsCaptcha">
                    <el-input 
                        class="captcha-sms"
                        type="text" 
                        :placeholder="$t('Placeholder.EnterSmsCaptcha')" 
                        v-model.trim="form.code" 
                        maxlength="6">
                        <div 
                            slot="append"  
                            @click="getSmsCaptcha" 
                            v-if="!showCountdown" 
                            v-loading="smsLoading">
                            {{ countdown === 0 ? $t('Form.Reacquire') : $t('Form.GetSmsCaptcha')}}
                        </div>
                        <div slot="append" v-if="showCountdown">{{`${countdown} ${$t('Form.Second')}`}}</div>
                    </el-input>
                </el-form-item>

                <div class="card-footer">
                    <el-button v-waves class="card-btn-previous" @click="handlePreviousClick">{{ $t('Button.Previous') }}</el-button>
                    <el-button 
                        v-waves 
                        :loading="btnLoading" 
                        class="card-btn-submit" 
                        type="primary" 
                        @click="handleSubmitClick">
                        {{ $t('Button.SignIn') }}
                    </el-button>
                </div>
            </el-form>
        </el-card>
    </div>
</template>

<script>
import moment from 'moment'
import waves from '@/directive/waves' // Waves directive
import trim from '@/directive/trim'
import {
    validate_companyNameZh,
    validate_companyNameEn,
    validate_departmentName,
    validate_positionName,
    validate_uname,
    validate_phone,
    validate_refereeName,
    validate_remark,
    validate_country,
    validate_region,
    validate_captcha_img,
    validate_captcha_sms,
} from '@/utils/validate/register'
import { FormMixin } from '@/mixins'
import { mapGetters } from 'vuex'
import { 
    apiGetCaptcha,
    apiGetProvinceList,
    apiSendSmsCaptcha,
    apiValidatePhone
} from '@/api/register'

export default {
    props: {
        title: { type: String, default: '' },
    },
    name: 'CompanyInfoCard',
    directives: { waves, trim },
    mixins: [FormMixin],
    data() {
        return {
            smsLoading: false,   //获取短信验证码按钮loading
            btnLoading: false,   //注册按钮loading
            provinceList: [],    //省份列表
            form: {
                companyNameZh: '', //公司中文名
                companyNameEn: '',  //公司英文名
                departmentName: '', // 所属部门
                positionName: '', // 职位
                uname: '', // 姓名
                phone: '', // 手机号
                refereeName: '', // 推荐人
                remark: '', // 备注
                country: '1', // 国家 （'0': 中国; '1': '非中国'）
                region: null, // 所在区域 
                captcha: '',  //图形验证码
                code: '',  //短信验证码
            },
            rules: {
                companyNameZh: { validator: validate_companyNameZh.bind(this), trigger: 'blur' },
                companyNameEn: { validator: validate_companyNameEn.bind(this), trigger: 'blur' },
                departmentName: { validator: validate_departmentName.bind(this), trigger: 'blur' },
                positionName: { validator: validate_positionName.bind(this), trigger: 'blur' },
                uname: { validator: validate_uname.bind(this), trigger: 'blur' },
                phone: { validator: validate_phone.bind(this), trigger: 'blur' },
                refereeName: { validator: validate_refereeName.bind(this), trigger: 'blur' },
                remark: { validator: validate_remark.bind(this), trigger: 'blur' },
                country: { validator: validate_country.bind(this), trigger: 'change' },
                region: { validator: validate_region.bind(this), trigger: 'change' },
                captcha: { validator: validate_captcha_img.bind(this), trigger: 'blur' },
                code: { validator: validate_captcha_sms.bind(this), trigger: 'blur' },
            },
            captchaImgUrl: '',
            showSmsCaptcha: true, //是否显示短信验证码输入框
            countdown: 60,        //短信验证码倒计时初始值
            showCountdown: false, //是否显示短信验证码倒计时
            timer: null,          //倒计时定时器
        }
    },
    computed: {
        //国家列表
        countryList(){
            return [
                {value: '0', label: this.$t('Form.China')},
                {value: '1', label: this.$t('Form.NonChina')},
            ]
        },
        regionProps() {
            return {
                label: { 'zh': 'label', 'en': 'labelEn' }[this.language],
                emitPath: false,
            }
        },
        ...mapGetters(['language']),
    },
    methods: {
        async getRegionList(){
            const res = await apiGetProvinceList()
            this.provinceList = res.data.list
        },
        // 获取图形验证码
        getImgCaptcha() {
            this.captchaImgUrl = apiGetCaptcha.url + '?timestamp=' + new Date().getTime() + '&email=' + this.$parent.userInfo.email
        },
        //获取短信验证码
        getSmsCaptcha(){
            if(this.form.phone){
                // 验证手机号是否被注册过
                apiValidatePhone({ phone: this.form.phone })
                    .then(res => {
                        this.smsLoading = true
                        apiSendSmsCaptcha({
                            phone: this.form.phone,
                            status: 0 
                        }).then(res => {
                            //调取获取短信验证码的接口，成功后弹出提示并开始倒计时
                            this.smsLoading = false
                            this.$message.success(this.$t('Message.SendSuccess'))
                            this.showCountdown = true  //显示短信验证码倒计时 
                            this.countdownFun()
                        }).catch(err => {
                            this.smsLoading = false
                            this.$message.error(this.$t( `Message.MsgCode${err.code}`))
                        })
                    }).catch(err => {
                        if (err.code === 554){
                            this.$message.error(this.$t('Validate.Phone.IsRegistered'))
                        } else {
                            this.$message.error(this.$t('Validate.Phone.IsExists'))
                        }
                    })
            }else{
                this.$message.warning(this.$t('Message.NotPhone'))
            }
        },
        //倒计时函数
        countdownFun() {
            this.countdown = 60
            this.timer = setInterval(() =>{
                this.countdown--;
                if (this.countdown == 0) {
                    this.clearCountdown()
                } 
            },1000)
        },
        // 清除倒计时
        clearCountdown() {
            clearInterval(this.timer);
            this.showCountdown = false
        },
        handlePreviousClick() {
            this.$emit('previousStep')
        },
        handleSubmitClick() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    this.form.provinceCode = this.form.country === '0' ? this.regionValueFormat(this.form.region) : '1'
                    this.$emit('submit', this.form)
                    this.btnLoading = true
                }
            })
        },
        handleRegionChange(value){
            // 区域选择改变，单独触发校验手机号
            this.$refs.form.validateField('region')
            if(this.form.phone){
                this.$refs.form.validateField('phone')
            }
            if(value === '1'){
                this.form.region = ''
            }

            // 所在区域是 非中国 或 中国（台湾/香港/澳门）隐藏短信验证码输入框
            if(this.regionValueFormat(value) === '1'){
                this.showSmsCaptcha = false
                //若存在定时器，则清除定时器
                if(this.timer){
                    this.clearCountdown()
                }
            }else{
                this.showSmsCaptcha = true
            }
        },
        regionValueFormat(value){
            if(value === '1' || value === '710000' || value === '810000' || value === '820000'){
                return '1'
            }else{
                return value
            }
        },
    },
    watch: {
        language(language) {
            if (language) {
                this.$refs.form.resetFields()  //重置表单
                this.clearCountdown()          //清除倒计时
            }
        },
    },
    mounted(){
        this.$nextTick(() => {
            this.getRegionList()  //获取省份列表
            this.getImgCaptcha()  //获取图形验证码
        })
    },
    beforeDestroy(){
        // vue实例销毁前，若存在定时器则清除
        if(this.timer) clearInterval(this.timer)
    },
}
</script>

<style lang="scss" scoped>
$color-theme: #4da1ff;
$color-black: #000000;

.region-select{
    ::v-deep .el-input{
        .el-input__inner{
            height: 40px !important;
        }
    }
}

.card-footer {
    .card-btn-previous {
        width: 40%;
    }
    .card-btn-submit {
        width: 40%;
    }
}
.captcha-img {
    ::v-deep .el-input__suffix{
        right: 0 !important;
        border: 1px solid #bbb;
        border-radius: 0 25px 25px 0;
    }

    img{
        width: 160px;
        height: 38px;
        cursor: pointer;

        border-top-right-radius: 25px;
        border-bottom-right-radius: 25px;
    }
}

.captcha-sms{
    ::v-deep .el-input__inner{
        border-radius: 25px 0 0 25px !important;
    }

    ::v-deep .el-input-group__append{
        width: 160px;
        padding: 0;
        border: 1px solid #bbb;
        border-left: 0;
        border-radius: 0 25px 25px 0;
        color: $color-black;
        background-image: linear-gradient(to right ,#C1C1C1, #F8F8F8);
        cursor: pointer;
        text-align: center;

        .el-loading-mask{
            top: -9px;
            bottom: -10px;
            border-radius: 0 25px 25px 0;
        }
    }
}
</style>
